import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { SearchDispatcherEvent } from '~/native/srp/dispatchers/constants';
import sendMessageToNative from '~/native/srp/dispatchers/sendMessageToNative';

export default function useAppliedFiltersDispatcher() {
  const { appliedFilters } = useContext(AppliedFiltersContext);

  useSubsequentEffect(() => {
    sendMessageToNative(SearchDispatcherEvent.AppliedFilters, {});
  }, [appliedFilters]);
}
